import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { Routes, rootRouteRef } from './routes';

export const confidencePulsePlugin = createPlugin({
  id: 'confidence-pulse',
  routes: {
    ...Routes,
  },
});

export const ConfidencePulsePage = confidencePulsePlugin.provide(
  createRoutableExtension({
    name: 'ConfidencePulsePage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-pulse", webpackPrefetch: 5 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
